/**
 * @generated SignedSource<<2202c09a8d1d4e9c64a281625c4cb04f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActivePixCobValue_pixQrCode$data = {
  readonly company: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveValue_company">;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentActivePixCobValue_pixQrCode";
};
export type PaymentActivePixCobValue_pixQrCode$key = {
  readonly " $data"?: PaymentActivePixCobValue_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActivePixCobValue_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActivePixCobValue_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentLinkActiveValue_company"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "2963b611256a393b8a793272d27bff67";

export default node;
